import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  DestroyRef,
  ChangeDetectorRef
} from '@angular/core';
import { PitchCardModalBase } from '../pitchcard-modal-base';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ShareBusinessComponent } from '../../../share-business/share-business.component';

@Component({
  selector: 'app-pitchcard-share-modal',
  standalone: true,

  imports: [CommonModule, DialogModule, ShareBusinessComponent],
  templateUrl: './pitchcard-share-modal.component.html'
})
export class PitchCardShareModalComponent extends PitchCardModalBase {
  @Input() showShareBusinessDialog: any;
  @Input() shareTitle: any;
  @Input() shareBusinessUrl: any;
  @Input() currentPitchCard: any;
  @Input() isMobile: any;
  @Input() isEmbedded: any;
  @Input() isPortraitMode: any;
  @Output() shareClosed = new EventEmitter<void>();
}
